import React from 'react';
import { Listbox } from '@headlessui/react';
import { CheckIcon, ChevronDownIcon } from '@heroicons/react/20/solid';

const ListBoxComponent = ({ selected, options, className = '', onChange }) => {
  const getColor = () => {
    if (selected === options[0])
      return {
        base: 'green-500',
        hover: 'green-300',
        text: 'green-700',
        ring: 'green-300',
      };
    if (selected === options[1])
      return {
        base: 'red-500',
        hover: 'red-300',
        text: 'red-700',
        ring: 'red-300',
      };
    return {
      base: 'purple-500',
      hover: 'purple-600',
      text: 'purple-700',
      ring: 'purple-300',
    };
  };

  const colors = getColor();

  console.log(colors);

  return (
    <Listbox
      as="div"
      onChange={onChange}
      value={selected}
      className={`relative ${className}`}
    >
      <div
        className={`inline-flex divide-x divide-${colors.base} rounded-md shadow-sm border border-${colors.ring}`}
      >
        <div
          className={`inline-flex items-center gap-x-1.5 rounded-l-md bg-${colors.base} px-3 py-2 text-white shadow-md shadow-${colors.base}`}
        >
          <CheckIcon className="-ml-0.5 h-5 w-5 text-white" />
          <p className="text-sm font-semibold">{selected?.name || selected}</p>
        </div>
        <Listbox.Button
          className={`rounded-l-none rounded-r-md bg-${colors.base} p-2 hover:bg-${colors.hover} focus:outline-none `}
        >
          <ChevronDownIcon className="h-5 w-5 text-white" />
        </Listbox.Button>
      </div>
      <Listbox.Options className="absolute left-0 z-10 mt-2 w-36 bg-white shadow-lg ring-1 ring-black/5 focus:outline-none">
        {options.map((option) => (
          <Listbox.Option
            key={option?.name || option}
            value={option}
            className={`cursor-pointer select-none p-4 text-sm text-gray-900 hover:bg-gray-100 hover:text-white transition-all duration-200`}
          >
            <div className="flex justify-between items-center">
              <p className={`font-normal text-${colors.text}`}>
                {option?.name || option}
              </p>
              {selected === option && (
                <CheckIcon className={`h-5 w-5 text-${colors.text}`} />
              )}
            </div>
            {option.description && (
              <p className="mt-2 text-gray-500 text-xs">{option.description}</p>
            )}
          </Listbox.Option>
        ))}
      </Listbox.Options>
    </Listbox>
  );
};

export default ListBoxComponent;
